import { FC, useState } from "react";
import { Outlet } from "react-router-dom";
import ConsoleSidebar from "./ConsoleSidebar";

const MainConsoleComponent: FC = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    return (
        <div className="flex justify-between">
            <div className="relative w-60px h-[100vh]">
                <ConsoleSidebar isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
            </div>
            <div className={`relative w-[calc(100vw-60px)] bg-light-bg-700 dark:bg-dark-bg-800`}>
                {isExpanded && <div className="absolute inset-0 bg-black opacity-30 z-10 pointer-events-auto"></div>}
                <main>
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default MainConsoleComponent;
